// extracted by mini-css-extract-plugin
export default {"region":"SJpwoQzYMiP38FQ7WjFk","arrow":"YmJNk01XVCc5sKBSiHNc","title":"kNzmqUuKjqwx8iRvUEmw"};